import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { REPLY_REQUEST, ReplyConfig, REQUEST_STATUS, REQUEST_TYPE } from '../../_core/approvals-page.model';
import { I18nModule } from '@spartacus/core';

@Component({
  selector: 'modal-request-actions',
  standalone: true,
  imports: [CommonModule, I18nModule],
  templateUrl: './modal-request-actions.component.html',
  styleUrl: './modal-request-actions.component.scss',
})
export class ModalRequestActionsComponent {
  @Input() code!: string;
  @Input() status!: REQUEST_STATUS;
  @Input() approvalsUser?: string;
  @Input() approvalsDate?: Date;
  @Input() validation?: () => boolean;
  @Input() replyConfig!: ReplyConfig;

  @Output() _onReply = new EventEmitter<ReplyConfig>();
  @Output() _onClose = new EventEmitter<void>();

  REQUEST_TYPE = REQUEST_TYPE;
  REPLY_REQUEST = REPLY_REQUEST;
  REQUEST_STATUS = REQUEST_STATUS;

  close() {
    this._onClose.emit();
  }

  reply(status: REPLY_REQUEST) {
    if (status === REPLY_REQUEST.APPROVE && this.validation && !this.validation()) {
      return;
    }

    this._onReply.emit({
      type: this.replyConfig.type,
      code: this.code,
      status,
      registerData: this.replyConfig.registerData,
    });
  }
}
